/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLocalizedString, FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLocalizedStringFromJSONTyped, FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLocalizedStringToJSON, } from './FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLocalizedString';
export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherLeaderboardConfigDescriptionMarkdownFromJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherLeaderboardConfigDescriptionMarkdownFromJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherLeaderboardConfigDescriptionMarkdownFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLocalizedString(json)) {
        return FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLocalizedStringFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherLeaderboardConfigDescriptionMarkdownToJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherLeaderboardConfigDescriptionMarkdownToJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherLeaderboardConfigDescriptionMarkdownToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLocalizedString(value)) {
        return FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLocalizedStringToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherLeaderboardConfigDescriptionMarkdown.js.map